import apiUpload from '@/services/api/modules/upload.js'
import apiDownload from '@/services/api/modules/download'
import app from '@/main'

/**
 *
 * @param {*} fileName oss 上面的key
 * @param {*} recommandUserFileName 建议用户使用的文件名
 * @returns
 */
export async function downloadFileFromOss(fileName = '', recommandUserFileName) {
  if (!fileName) {
    app.$message.error('未提供文件名称')
    return
  }
  try {
    const res = await apiUpload.fetchDownloadUrlByOssFileName({
      fileName
    })
    const { code, data: downloadUrl } = res || {}
    if (code !== 200 || !downloadUrl) {
      return
    }

    if (!recommandUserFileName) {
      // 没有提供 建议用户文件名
      window.open(downloadUrl)
      return
    }

    // 提供了 建议用户文件名
    apiDownload.fetchDownloadGetGeneric(downloadUrl, {}, {}, recommandUserFileName)
  } catch (err) {
    console.log(err)
  }
}
